import { useEffect, useState } from "react";
import { isInPreviewEditor } from "../utils/storyblok/is-in-preview-editor";

export const useIsInPreviewEditor = (): boolean => {
	const [isInPreviewEditorState, setIsInPreviewEditor] = useState(false);

	useEffect(() => {
		setIsInPreviewEditor(isInPreviewEditor());
	}, []);

	return isInPreviewEditorState;
};
